export default {
  methods: {
    uuid (sufix, prefix = 'uid') {
      return `${prefix}-${this._uid}-${sufix}`
    },
  },
}
